export default __webpack_public_path__ + "static/media/sophie-squared.fff413db.png";